import classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Col, Row } from 'reactstrap';

import globalTranslations from '../../../../i18n/globalTranslations';
import FormModel from '../../../../models/Form';
import { modelOf } from '../../../../prop-types';
import CheckoutStore from '../../../../store/CheckoutStore';
import FormFieldId from '../../../../types/FormFieldId';
import CheckboxField from '../../../form/CheckboxField';
import FormGroupField from '../../../form/FormGroupField';

const createOption = ({ value, label }) => {
  return {
    value,
    label,
  };
};

const CheckoutCustomerInfoForm = ({ checkoutStore, onOrderUpdate, form }) => {
  const { customerInfoIsLoading, order } = checkoutStore;
  const disabled = customerInfoIsLoading;

  const emailFormField = form.getField(FormFieldId.BILLING_EMAIL);
  const newsletterFormField = form.getField(
    FormFieldId.NEWSLETTER_SUBSCRIPTION
  );

  const handleChange = (e) => {
    const emailField = order.getCustomerField(FormFieldId.BILLING_EMAIL).field;

    const value = e.target.value;
    emailField.setValue(value);
  };

  const handleBlur = () => {
    onOrderUpdate({ withoutTimer: true });
  };

  const updateNewsLetterState = () => {
    const newsletterField = order.getCustomerField(
      FormFieldId.NEWSLETTER_SUBSCRIPTION
    ).field;

    const value = newsletterField.value;
    newsletterField.setValue(!value);

    onOrderUpdate({ withoutTimer: true });
  };

  return (
    <div
      className={classNames('CheckoutCustomerInfoForm', {
        'CheckoutCustomerInfoForm--newsletter-disabled':
          !newsletterFormField.active,
      })}
    >
      <Row>
        <Col xl={6} sm={12}>
          <FormGroupField
            field={emailFormField}
            fieldName={FormFieldId.BILLING_COMPANY}
            formName={'checkout'}
            floatingLabel
            label={<FormattedMessage {...globalTranslations.emailTitle} />}
            type={emailFormField.type.toLowerCase()}
            onChange={handleChange}
            required={emailFormField.required}
            minLength={emailFormField.min_length}
            maxLength={emailFormField.max_length}
            onBlur={handleBlur}
          />
        </Col>
      </Row>
      {newsletterFormField.active && (
        <Row>
          <Col>
            <CheckboxField
              field={newsletterFormField}
              fieldName={FormFieldId.NEWSLETTER_SUBSCRIPTION}
              formName={'checkout'}
              options={createOption({
                value: newsletterFormField.value,
                label: (
                  <FormattedMessage
                    id="newsletter.popdownTitleWithoutDiscount"
                    defaultMessage="Subscribe to our free newsletter!"
                  />
                ),
              })}
              onChange={updateNewsLetterState}
              inline
              disabled={disabled}
            />
          </Col>
        </Row>
      )}
    </div>
  );
};

CheckoutCustomerInfoForm.propTypes = {
  checkoutStore: modelOf(CheckoutStore).isRequired,
  form: modelOf(FormModel).isRequired,
  onOrderUpdate: PropTypes.func.isRequired,
};

export default inject('checkoutStore')(observer(CheckoutCustomerInfoForm));
